import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { soundOn, setSoundOn, playCoin } from "@/lib/celebrate";

export function SoundToggle({ compact = false }) {
  const [on, setOn] = useState(soundOn());
  const toggle = () => { setSoundOn(!on); setOn(!on); if (!on) playCoin(1); };
  return (
    <button type="button" onClick={toggle} data-testid="games-sound-toggle" aria-label={on ? "Sounds ausschalten" : "Sounds einschalten"}
      className={`ml-auto shrink-0 whitespace-nowrap inline-flex items-center gap-1.5 h-10 ${compact ? "w-10 justify-center" : "px-4"} rounded-full text-sm font-bold transition-colors ${on ? "bg-rose-50 text-rose-600 ring-1 ring-rose-100" : "bg-slate-100 text-slate-500"}`}>
      {on ? <Volume2 className="w-4 h-4" /> : <VolumeX className="w-4 h-4" />} {!compact && (on ? "Sound an" : "Stumm")}
    </button>
  );
}
